/* eslint-disable global-require */
const STORAGE_KEY = "nm_categories_content";

const DEFAULT_IMAGE = require("../service-preview/img/service-01.png");
const DEFAULT_OVERVIEW_IMAGE = require("../service-overview/img/service-overview.jpg");
/* eslint-enable global-require */

const CYRILLIC_MAP = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

const DEFAULT_CATEGORY_SEED = [
  {
    key: "outdoor",
    slug: "naruzhnaya-reklama",
    title: "Наружная реклама",
    subtitle: "Производство и монтаж наружной рекламы: вывески, световые короба, панель-кронштейны и комплексное оформление фасадов.",
    nextSlug: "interernaya-reklama",
    points: [
      { id: "o1", name: "Вывески и объёмные буквы" },
      { id: "o2", name: "Световые короба и лайтбоксы" },
      { id: "o3", name: "Панель-кронштейны" },
      { id: "o4", name: "Крышные установки" },
      { id: "o5", name: "Оформление фасадов" },
      { id: "o6", name: "Монтаж и обслуживание" },
    ],
  },
  {
    key: "interior",
    slug: "interernaya-reklama",
    title: "Интерьерная реклама",
    subtitle: "Комплексные решения по интерьерной рекламе: проектирование, изготовление, монтаж и сопровождение. Прозрачная смета, соблюдение сроков и гарантия качества.",
    nextSlug: "oformlenie-muzeev",
    points: [
      { id: "s1", name: "Проектирование и дизайн: дизайн-проекты, сметы и технические чертежи" },
      { id: "s2", name: "Точные замеры на объекте" },
      { id: "s3", name: "Изготовление элементов: навигация, таблички, панно, лайтбоксы, POS-материалы" },
      { id: "s4", name: "Электротехнические работы и подсветка" },
      { id: "s5", name: "Монтаж и демонтаж" },
      { id: "s6", name: "Координация и согласования с арендаторами и архитекторами" },
      { id: "s7", name: "Диагностика, обслуживание и ремонт интерьерных конструкций" },
    ],
  },
  {
    key: "museums",
    slug: "oformlenie-muzeev",
    title: "Оформление музеев и кабинетов охраны труда",
    subtitle: "Полный цикл работ: концепция, производство и монтаж экспозиций и информационных зон.",
    nextSlug: "naruzhnaya-reklama",
    points: [
      { id: "m1", name: "Информационные стенды" },
      { id: "m2", name: "Оформление навигации" },
      { id: "m3", name: "Оформление витрин и ресепшен" },
      { id: "m4", name: "Неоновые вывески" },
      { id: "m5", name: "Пресс Волл" },
      { id: "m6", name: "Ростовые фигуры" },
      { id: "m7", name: "Ролл ап" },
      { id: "m8", name: "Промо стойка" },
    ],
  },
  { key: "transport", title: "Реклама в общественном транспорте" },
  { key: "transport-branding", title: "Брендирование транспорта" },
  { key: "art-objects", title: "Арт-объекты, стелы, инсталяции" },
  { key: "education", title: "Оформление учебных заведений" },
  { key: "honor-boards", title: "изготовление и монтаж досок почета" },
  { key: "polygraphy", title: "Полиграфическая продукция" },
  { key: "souvenirs", title: "Сувенирная продукция" },
  { key: "wide-format", title: "Широкоформатная печать" },
  { key: "milling-laser", title: "Фрезерная и лазерная резка материала" },
  { key: "branding-digital", title: "Брендинг, маркетинг, Digital" },
];

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function createId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function buildTitleHtml(title) {
  const words = String(title || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  if (words.length === 1) return `<span>${escapeHtml(words[0])}</span>`;
  return `<span>${escapeHtml(words[0])}</span> ${escapeHtml(words.slice(1).join(" "))}`;
}

function sanitizeTitleHtml(html) {
  if (window.NMSanitize?.sanitizeTitleHtml) return window.NMSanitize.sanitizeTitleHtml(html);
  return String(html || "")
    .replace(/<(?!\/?span\b)[^>]*>/gi, "")
    .replace(/<\/?span\b[^>]*>/gi, (tag) => (/^<\/span/i.test(tag) ? "</span>" : "<span>"));
}

function slugify(value) {
  const slug = String(value || "")
    .trim()
    .toLowerCase()
    .split("")
    .map((char) => {
      if (CYRILLIC_MAP[char] !== undefined) return CYRILLIC_MAP[char];
      if (/[a-z0-9]/.test(char)) return char;
      if (char === " " || char === "_" || char === "-") return "-";
      return "";
    })
    .join("")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return slug || "category";
}

function uniqueSlug(base, excludeId, categories) {
  const source = Array.isArray(categories) ? categories : [];
  const root = base || "category";
  const used = source
    .filter((item) => item.id !== excludeId)
    .map((item) => item.slug);
  if (!used.includes(root)) return root;
  let index = 2;
  let candidate = `${root}-${index}`;
  while (used.includes(candidate)) {
    index += 1;
    candidate = `${root}-${index}`;
  }
  return candidate;
}

function uniqueKey(base, excludeId, categories) {
  const source = Array.isArray(categories) ? categories : [];
  const root = base || "category";
  const used = source
    .filter((item) => item.id !== excludeId)
    .map((item) => item.key);
  if (!used.includes(root)) return root;
  let index = 2;
  let candidate = `${root}-${index}`;
  while (used.includes(candidate)) {
    index += 1;
    candidate = `${root}-${index}`;
  }
  return candidate;
}

const SERVICE_SECTION_SLUG = "izgotovlenie-reklamy";

function getServicePath(category) {
  const slug = encodeURIComponent(category.slug || category.key || category.id);
  return `/uslugi/${SERVICE_SECTION_SLUG}/${slug}`;
}

function normalizePoint(item = {}) {
  const name = String(item.name || item.title || "").trim();
  if (!name) return null;
  return {
    id: String(item.id || createId()),
    name,
  };
}

function normalizeCategory(item = {}, allCategories = []) {
  const title = String(item.title || "").trim();
  if (!title) return null;

  const id = String(item.id || createId());
  const slug = uniqueSlug(
    String(item.slug || "").trim() || slugify(title),
    id,
    allCategories,
  );
  const key = uniqueKey(
    String(item.key || "").trim() || slug,
    id,
    allCategories,
  );
  const points = (Array.isArray(item.points) ? item.points : [])
    .map(normalizePoint)
    .filter(Boolean);

  const customImage = String(item.image || "").trim();
  return {
    id,
    key,
    slug,
    title,
    titleHtml: sanitizeTitleHtml(String(item.titleHtml || "").trim()) || buildTitleHtml(title),
    subtitle: String(item.subtitle || "").trim(),
    image: customImage || DEFAULT_IMAGE,
    overviewImage: String(item.overviewImage || "").trim() || DEFAULT_OVERVIEW_IMAGE,
    nextSlug: String(item.nextSlug || "").trim(),
    servicesTitle: String(item.servicesTitle || "").trim() || `Услуги ${title.toLowerCase()}:`,
    points,
  };
}

function resolveCategoryImage(category) {
  const image = String(category?.image || "").trim();
  if (image) {
    const safe = window.NMSanitize?.safeHref?.(image, { allowData: true });
    if (safe) return safe;
    if (image.startsWith("/") || image.startsWith("data:image/") || image.startsWith("http")) {
      return image;
    }
  }
  return DEFAULT_IMAGE;
}

function getDefaultData() {
  const categories = [];
  DEFAULT_CATEGORY_SEED.forEach((item) => {
    const normalized = normalizeCategory(item, categories);
    if (normalized) categories.push(normalized);
  });
  return { categories };
}

function normalizeData(raw) {
  if (!raw || typeof raw !== "object") return getDefaultData();
  const incoming = Array.isArray(raw.categories) ? raw.categories : [];
  const categories = [];
  incoming.forEach((item) => {
    const normalized = normalizeCategory(item, categories);
    if (normalized) categories.push(normalized);
  });
  return { categories: categories.length ? categories : getDefaultData().categories };
}

function getCategoriesData() {
  const cached = window.NMApi?.cache?.categories;
  if (cached) return normalizeData(cached);
  return getDefaultData();
}

function saveCategoriesData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.categories = normalized;
    window.NMApi.save("categories", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить категории"); // eslint-disable-line no-alert
    });
  }
  document.dispatchEvent(new CustomEvent("nm:categories-updated", { detail: normalized }));
  return normalized;
}

function getCategories() {
  return getCategoriesData().categories;
}

function getCategoryMap(data) {
  const source = data || getCategoriesData();
  return (source.categories || []).reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
  }, {});
}

function getCategoryKeys(data) {
  return getCategories(data).map((item) => item.key);
}

function getCategoryByKey(key, data) {
  const source = data || getCategoriesData();
  return source.categories.find((item) => (
    item.key === key || item.slug === key || item.id === key
  )) || null;
}

function getCategoryBySlug(slug, data) {
  return getCategoryByKey(slug, data);
}

function getNextCategory(category, data) {
  const source = data || getCategoriesData();
  const list = source.categories;
  if (!category || !list.length) return null;
  if (category.nextSlug) {
    const selected = getCategoryBySlug(category.nextSlug, source);
    if (selected && selected.id !== category.id) return selected;
  }
  const index = list.findIndex((item) => item.id === category.id);
  if (index < 0) return list[0];
  return list[(index + 1) % list.length];
}

function upsertCategory(category) {
  const data = getCategoriesData();
  const payload = normalizeCategory(category, data.categories);
  if (!payload) return null;
  const index = data.categories.findIndex((item) => item.id === payload.id);
  if (index >= 0) {
    data.categories[index] = payload;
  } else {
    data.categories.push(payload);
  }
  return saveCategoriesData(data);
}

function deleteCategory(idOrKey, { fallbackKey } = {}) {
  const data = getCategoriesData();
  const target = data.categories.find((item) => (
    item.id === idOrKey || item.key === idOrKey || item.slug === idOrKey
  ));
  if (!target) return data;

  const remaining = data.categories.filter((item) => item.id !== target.id);
  const fallback = remaining.find((item) => item.key === fallbackKey) || remaining[0] || null;
  data.categories = remaining;
  const saved = saveCategoriesData(data);

  document.dispatchEvent(new CustomEvent("nm:category-deleted", {
    detail: {
      deletedKey: target.key,
      deletedSlug: target.slug,
      fallbackKey: fallback?.key || "",
    },
  }));

  return saved;
}

window.NMCategoriesContent = {
  STORAGE_KEY,
  DEFAULT_IMAGE,
  DEFAULT_OVERVIEW_IMAGE,
  escapeHtml,
  createId,
  buildTitleHtml,
  resolveCategoryImage,
  slugify,
  uniqueSlug,
  uniqueKey,
  SERVICE_SECTION_SLUG,
  getServicePath,
  normalizePoint,
  normalizeCategory,
  getDefaultData,
  getCategoriesData,
  saveCategoriesData,
  getCategories,
  getCategoryMap,
  getCategoryKeys,
  getCategoryByKey,
  getCategoryBySlug,
  getNextCategory,
  upsertCategory,
  deleteCategory,
};

// Ensure store is initialized on first load.
getCategoriesData();

window.NMApi?.ready?.then(() => {
  window.NMServicesContent?.hydratePublicServices?.();
  window.NMPortfolioContent?.hydratePortfolio?.();
});
